const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,20.392157%,20%)",
      fillOpacity: 1
    },
    d: "M 45.511719 53.710938 L 4.410156 53.710938 C 1.980469 53.710938 0 52.09375 0 50.105469 L 0 3.605469 C 0 1.617188 1.980469 0 4.410156 0 L 47.84375 0 C 50.273438 0 52.253906 1.617188 52.253906 3.605469 L 52.253906 46.789062 C 52.253906 47.347656 51.699219 47.800781 51.015625 47.800781 C 50.335938 47.800781 49.78125 47.34375 49.78125 46.789062 L 49.78125 3.605469 C 49.78125 2.730469 48.914062 2.023438 47.847656 2.023438 L 4.410156 2.023438 C 3.34375 2.023438 2.476562 2.730469 2.476562 3.605469 L 2.476562 50.105469 C 2.476562 50.980469 3.34375 51.6875 4.410156 51.6875 L 45.511719 51.6875 C 46.195312 51.6875 46.75 52.140625 46.75 52.699219 C 46.75 53.253906 46.195312 53.710938 45.511719 53.710938 Z M 45.511719 53.710938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,20.392157%,20%)",
      fillOpacity: 1
    },
    d: "M 47.84375 53.714844 L 43.832031 53.714844 C 43.148438 53.714844 42.59375 53.257812 42.59375 52.703125 C 42.59375 52.144531 43.152344 51.691406 43.832031 51.691406 L 47.84375 51.691406 C 48.910156 51.691406 49.777344 50.984375 49.777344 50.109375 L 49.777344 44.996094 C 49.777344 44.4375 50.335938 43.988281 51.015625 43.988281 C 51.695312 43.988281 52.25 44.441406 52.25 44.996094 L 52.25 50.109375 C 52.253906 52.09375 50.273438 53.714844 47.84375 53.714844 Z M 47.84375 53.714844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,20.392157%,20%)",
      fillOpacity: 1
    },
    d: "M 58.34375 54.089844 C 57.660156 54.089844 57.105469 53.632812 57.105469 53.078125 L 57.105469 9.894531 C 57.105469 9.023438 56.242188 8.3125 55.167969 8.3125 C 54.484375 8.3125 53.933594 7.859375 53.933594 7.300781 C 53.933594 6.742188 54.488281 6.289062 55.167969 6.289062 C 57.601562 6.289062 59.585938 7.90625 59.585938 9.894531 L 59.585938 53.078125 C 59.585938 53.636719 59.027344 54.089844 58.34375 54.089844 Z M 58.34375 54.089844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,20.392157%,20%)",
      fillOpacity: 1
    },
    d: "M 52.839844 60 L 11.738281 60 C 9.304688 60 7.324219 58.382812 7.324219 56.394531 C 7.324219 55.835938 7.878906 55.382812 8.5625 55.382812 C 9.246094 55.382812 9.800781 55.839844 9.800781 56.394531 C 9.800781 57.265625 10.671875 57.976562 11.738281 57.976562 L 52.839844 57.976562 C 53.523438 57.976562 54.078125 58.429688 54.078125 58.984375 C 54.078125 59.542969 53.523438 60 52.839844 60 Z M 52.839844 60 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,20.392157%,20%)",
      fillOpacity: 1
    },
    d: "M 55.167969 60 L 51.160156 60 C 50.476562 60 49.921875 59.546875 49.921875 58.988281 C 49.921875 58.433594 50.480469 57.976562 51.160156 57.976562 L 55.167969 57.976562 C 56.238281 57.976562 57.105469 57.269531 57.105469 56.398438 L 57.105469 51.289062 C 57.105469 50.730469 57.664062 50.277344 58.34375 50.277344 C 59.023438 50.277344 59.582031 50.730469 59.582031 51.289062 L 59.582031 56.398438 C 59.582031 58.382812 57.601562 60 55.167969 60 Z M 55.167969 60 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,20.392157%,20%)",
      fillOpacity: 1
    },
    d: "M 23.632812 8.390625 L 8.5625 8.390625 C 7.878906 8.390625 7.324219 7.9375 7.324219 7.378906 C 7.324219 6.820312 7.878906 6.367188 8.5625 6.367188 L 23.632812 6.367188 C 24.316406 6.367188 24.867188 6.820312 24.867188 7.378906 C 24.867188 7.9375 24.3125 8.390625 23.632812 8.390625 Z M 23.632812 8.390625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,20.392157%,20%)",
      fillOpacity: 1
    },
    d: "M 23.632812 13.582031 L 8.5625 13.582031 C 7.878906 13.582031 7.324219 13.132812 7.324219 12.574219 C 7.324219 12.015625 7.878906 11.5625 8.5625 11.5625 L 23.632812 11.5625 C 24.316406 11.5625 24.867188 12.015625 24.867188 12.574219 C 24.867188 13.132812 24.3125 13.582031 23.632812 13.582031 Z M 23.632812 13.582031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,20.392157%,20%)",
      fillOpacity: 1
    },
    d: "M 23.632812 18.777344 L 8.5625 18.777344 C 7.878906 18.777344 7.324219 18.324219 7.324219 17.765625 C 7.324219 17.207031 7.878906 16.753906 8.5625 16.753906 L 23.632812 16.753906 C 24.316406 16.753906 24.867188 17.207031 24.867188 17.765625 C 24.867188 18.324219 24.3125 18.777344 23.632812 18.777344 Z M 23.632812 18.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,20.392157%,20%)",
      fillOpacity: 1
    },
    d: "M 43.691406 35.824219 L 28.625 35.824219 C 27.941406 35.824219 27.386719 35.367188 27.386719 34.8125 C 27.386719 34.257812 27.941406 33.800781 28.625 33.800781 L 43.691406 33.800781 C 44.375 33.800781 44.925781 34.257812 44.925781 34.8125 C 44.925781 35.367188 44.375 35.824219 43.691406 35.824219 Z M 43.691406 35.824219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,20.392157%,20%)",
      fillOpacity: 1
    },
    d: "M 43.691406 42.472656 L 28.625 42.472656 C 27.941406 42.472656 27.386719 42.019531 27.386719 41.460938 C 27.386719 40.90625 27.941406 40.449219 28.625 40.449219 L 43.691406 40.449219 C 44.375 40.449219 44.925781 40.90625 44.925781 41.460938 C 44.925781 42.019531 44.375 42.472656 43.691406 42.472656 Z M 43.691406 42.472656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,20.392157%,20%)",
      fillOpacity: 1
    },
    d: "M 42.695312 23.96875 L 8.5625 23.96875 C 7.878906 23.96875 7.324219 23.519531 7.324219 22.960938 C 7.324219 22.402344 7.878906 21.949219 8.5625 21.949219 L 42.695312 21.949219 C 43.378906 21.949219 43.933594 22.402344 43.933594 22.960938 C 43.933594 23.519531 43.378906 23.96875 42.695312 23.96875 Z M 42.695312 23.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,20.392157%,20%)",
      fillOpacity: 1
    },
    d: "M 42.695312 29.164062 L 8.5625 29.164062 C 7.878906 29.164062 7.324219 28.710938 7.324219 28.152344 C 7.324219 27.59375 7.878906 27.140625 8.5625 27.140625 L 42.695312 27.140625 C 43.378906 27.140625 43.933594 27.59375 43.933594 28.152344 C 43.933594 28.710938 43.378906 29.164062 42.695312 29.164062 Z M 42.695312 29.164062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,20.392157%,20%)",
      fillOpacity: 1
    },
    d: "M 42.695312 47.335938 L 8.5625 47.335938 C 7.878906 47.335938 7.324219 46.878906 7.324219 46.324219 C 7.324219 45.769531 7.878906 45.3125 8.5625 45.3125 L 42.695312 45.3125 C 43.378906 45.3125 43.933594 45.769531 43.933594 46.324219 C 43.933594 46.878906 43.378906 47.335938 42.695312 47.335938 Z M 42.695312 47.335938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,20.392157%,20%)",
      fillOpacity: 1
    },
    d: "M 43.691406 18.777344 L 33.738281 18.777344 C 33.054688 18.777344 32.5 18.324219 32.5 17.765625 L 32.5 7.378906 C 32.5 6.820312 33.054688 6.367188 33.738281 6.367188 L 43.691406 6.367188 C 44.375 6.367188 44.925781 6.820312 44.925781 7.378906 L 44.925781 17.765625 C 44.929688 18.324219 44.375 18.777344 43.691406 18.777344 Z M 34.980469 16.753906 L 42.453125 16.753906 L 42.453125 8.390625 L 34.980469 8.390625 Z M 34.980469 16.753906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,20.392157%,20%)",
      fillOpacity: 1
    },
    d: "M 18.515625 42.714844 L 8.5625 42.714844 C 7.878906 42.714844 7.324219 42.261719 7.324219 41.703125 L 7.324219 33.753906 C 7.324219 33.195312 7.878906 32.742188 8.5625 32.742188 L 18.515625 32.742188 C 19.199219 32.742188 19.753906 33.195312 19.753906 33.753906 L 19.753906 41.703125 C 19.753906 42.261719 19.199219 42.714844 18.515625 42.714844 Z M 9.800781 40.691406 L 17.277344 40.691406 L 17.277344 34.761719 L 9.800781 34.761719 Z M 9.800781 40.691406 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.57036bb184f6254447cfbc1895a9106e.svg";
export { ForwardRef as ReactComponent };